function getSubdomain() {
  // Dev override: on localhost you can simulate any subdomain by adding
  // ?subdomain=admin to the URL (persists in sessionStorage so it survives
  // navigation). Strictly localhost-gated so this can never accidentally
  // affect production.
  if (
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1")
  ) {
    try {
      const fromQuery = new URLSearchParams(window.location.search).get("subdomain");
      if (fromQuery) sessionStorage.setItem("dev_subdomain", fromQuery);
      const stored = sessionStorage.getItem("dev_subdomain");
      if (stored) return stored;
    } catch (_) {}
  }
  const windowURL = window.location.hostname;
  let subdomain = "";
  if (windowURL.includes("epicarealert.com")) {
    subdomain = windowURL.split(".")[0];
  } else {
    subdomain = "unds";
  }
  return subdomain;
}

// "admin" is the reserved subdomain for the platform-owner shell
// (admin.epicarealert.com). When this is true, App.tsx swaps in the
// SuperAdminDashboard instead of the normal per-org Dashboard, and
// org-scoped API calls (org-checker, claim, etc.) shouldn't happen.
export function isSuperAdminSubdomain(): boolean {
  return getSubdomain() === "admin";
}

// "Has admin-level permissions in their own org." Superadmins get this
// in any org they sign into — they aren't a separate persona from admin
// for org-scoped purposes, they're admin-and-then-some. Use this anywhere
// the old code said `role === "admin"`.
export function isAdminLike(role: string | undefined | null): boolean {
  return role === "admin" || role === "superadmin";
}

export default getSubdomain;
